
import * as React from 'react';
import { FlatButton } from 'material-ui';
import  { FontAwesomeIcon }  from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';


const transperant = '#f7f7f700';
const disabledColor = '#d2d1e0';
const enabledColor = '#4a90e2';

export default function ActionButton({text, disabled, inProgress, onClick}){

    const spinnerIcon = <FontAwesomeIcon 
                            icon={ faSpinner }
                            color={!inProgress ? transperant : disabledColor} 
                            spin={inProgress}  
                            size="xs" 
                            style={{margin: '0px 4px 3px'}}/>;
    return (
        <FlatButton 
            disabled={disabled}
            icon={spinnerIcon}
            fullWidth
            onClick={onClick}
            labelPosition="before"
            style={{color: disabled ? disabledColor : enabledColor, fontWeight: 500, paddingRight: '20px'}}
            hoverColor={transperant}
        >
            {text}
        </FlatButton>   
    );
}



// WEBPACK FOOTER //
// ./src/components/portal/buttons/actionButton.jsx